import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Contacts as ContactsIcon } from '@mui/icons-material';

const ContactsWidget = ({ onClick }) => {
  return (
    <Card 
      sx={{ 
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4,
        }
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ContactsIcon sx={{ fontSize: 40, color: 'primary.main' }} />
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Kontakter
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Se alle ansatte
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContactsWidget;
